import React, { PropsWithChildren } from 'react';
import { Control } from 'react-hook-form';

import { ICompanyAddressFormSchema } from './schema';
import { FormField } from '@/components/ui/form';
import InlineInput from '@/components/InlineInput';
import UfSelector from '@/components/QuerySelectors/UfSelector';
import CitySelector from '@/components/QuerySelectors/CitySelector';
import MaskedInput from '@/components/MaskedInput';

interface IProps extends PropsWithChildren {
  control: Control<ICompanyAddressFormSchema>;
  isLoading: boolean;
  onSubmit: React.FormEventHandler<HTMLFormElement>;
}

const AddressFormStepView: React.FC<IProps> = ({
  control,
  isLoading,
  onSubmit,
  children,
}) => (
  <form onSubmit={onSubmit}>
    <div className="grid gap-4 py-4">
      <FormField
        control={control}
        name="zipCode"
        render={({ field }) => (
          <InlineInput
            title="CEP"
            as={MaskedInput}
            maskOptions={{
              mask: '00000-000',
            }}
            disabled={isLoading}
            {...field}
          />
        )}
      />
      <FormField
        control={control}
        name="state"
        render={({ field: { ref: _, ...stateField } }) => (
          <FormField
            control={control}
            name="city"
            render={({ field: { ref: __, ...cityField } }) => (
              <>
                <InlineInput
                  className="w-full"
                  title="Estado"
                  as={UfSelector}
                  disabled={isLoading}
                  {...stateField}
                  onChange={(option) => {
                    stateField.onChange(option);
                    cityField.onChange(undefined);
                  }}
                />

                <InlineInput
                  className="w-full"
                  title="Cidade"
                  as={CitySelector}
                  disabled={isLoading}
                  stateId={stateField.value?.value}
                  {...cityField}
                />
              </>
            )}
          />
        )}
      />

      <FormField
        control={control}
        name="neighborhood"
        render={({ field }) => (
          <InlineInput title="Bairro" disabled={isLoading} {...field} />
        )}
      />
      <FormField
        control={control}
        name="street"
        render={({ field }) => (
          <InlineInput title="Rua" disabled={isLoading} {...field} />
        )}
      />
      <FormField
        control={control}
        name="number"
        render={({ field }) => (
          <InlineInput title="Número" disabled={isLoading} {...field} />
        )}
      />
      <FormField
        control={control}
        name="complement"
        render={({ field }) => (
          <InlineInput title="Complemento" disabled={isLoading} {...field} />
        )}
      />
    </div>
    {children}
  </form>
);

export default AddressFormStepView;
